// extracted by mini-css-extract-plugin
export default {"container":"Summary_container__hw6Sg","sumText":"Summary_sumText__3l7CJ","final":"Summary_final__J34tF","sumAmount":"Summary_sumAmount__MMN64","gapRemove":"Summary_gapRemove__Mz6bb"};